import React from 'react';

const debug = () => {
    return (
        <div></div>
    );
}

export default debug;
